import { Component, OnInit, Input } from '@angular/core';
import { SearchFilters } from '../search-panel/search-panel.model';
import { GETDashboardService } from '../dashboard.service';
import { Router } from '@angular/router';
import { FavouriteDialogService } from '../../favourite-dialog/favourite-dialog.service';
import { ImplementOverviewModel } from '../dashboard.model';
import { ImplementDetailsService } from '../../implement-details/implement-details.service';
import { ImplementHistoryVM } from '../../equipment-details/equipment-details.model';
import { ImplementCycleDetails } from '../../add-observation-point/add-observation-point-modal';
import { PreferencesService } from '../../../../../app/modules/preferences/preferences.service';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationsService } from 'angular2-notifications';


@Component({
  selector: 'app-implement-location-history',
  templateUrl: './implement-location-history.component.html',
  styleUrls: ['./implement-location-history.component.css']
})
export class ImplementLocationHistoryComponent implements OnInit {


  // Search Parameters
  @Input() searchParameters: SearchFilters = new SearchFilters();
  loading: boolean = false;
  @Input() favouriteId: number = 0;
  @Input() tabReplace: string = "True";
  ImplementDetalisList: ImplementOverviewModel[];
  historyDetails_: ImplementHistoryVM[] = [];
  historyDetails_2: ImplementHistoryVM[] = [];
  cycleDetails: ImplementCycleDetails[] = [];
  ImpLocationHistory: any[] = [];
  NewCycleList: any[] = [];
  newDAte: Date
  NewList: any[];
  MaxLength = 0;
  favouriteName: string
  constructor(private _dashboardService: GETDashboardService, private _router: Router,
    private _moduleService: ImplementDetailsService,
    private _favouritesService: FavouriteDialogService,
    private readonly _pref: PreferencesService,
    private router: Router,
    private _notify: NotificationsService) { }

  ngOnInit() {
    // if (this.searchParameters !== undefined && this.searchParameters != null) {
    //   //this.loading=true;
    //   this.loadImp_Location_History();
    // }

    if (this.favouriteId > 0) {
      //this.loading=true;
      this.loadfavouriteImp_Location_History();
    } else {
      if (this.searchParameters !== undefined && this.searchParameters != null) {
        //this.loading=true;
        this.loadImp_Location_History();
      }
    }
  }

  loadfavouriteImp_Location_History() {
    this.loading = true;
    var params: SearchFilters = {
      customer: [],
      jobsite: [],
      equipment: [],
      make: [],
      makeUC: [],
      model: [],
      implement: [],
      ImplementTypes: [],
      ComponentTypes: [],
      onEq: 3,
      evalA: false,
      evalB: false,
      evalC: false,
      evalX: false,
      NoImps: false,
      family: [],
      assetSerial: [],
      GETType: [],
      PageNumber: 0,
      PageSize: 0
    };

    this._favouritesService.LoadFavouriteDetails(this.favouriteId).subscribe(r => {
      this.favouriteName = r.FavouriteName;
    });
    //console.log("param", params)
    this._dashboardService.PerformFavoriteSearchImplementOverview(params, this.favouriteId).subscribe(result => {
      // console.log("resultimplemnt22222", result)
      this.ImplementDetalisList = result;
      this.ImpLocationHistory.push(this.ImplementDetalisList);

      this.ImpLocationHistory[0].map(x => {
        x["CycleDetails"] = null
        this.historyDetails_ = [];
        this.loadImplementHistoryDetails(x.implementId, x.serialNo);
      })
      this.loading = false;
    })
  }
  // loadImp_Location_History() {
  //   this.loading = true;
  //   var params: SearchFilters = {
  //     customer: this.searchParameters.customer,
  //     jobsite: this.searchParameters.jobsite,
  //     equipment: this.searchParameters.equipment,
  //     make: this.searchParameters.make,
  //     makeUC: this.searchParameters.makeUC,

  //     model: this.searchParameters.model,
  //     implement: this.searchParameters.implement,
  //     ImplementTypes: this.searchParameters.ImplementTypes,
  //     ComponentTypes: this.searchParameters.ComponentTypes,

  //     onEq: this.searchParameters.onEq,
  //     evalA: false,
  //     evalB: false,
  //     evalC: false,
  //     evalX: false,
  //     NoImps: this.searchParameters.NoImps,
  //     family: this.searchParameters.family,
  //     assetSerial: this.searchParameters.assetSerial,
  //     GETType: this.searchParameters.GETType,
  //     PageNumber: 0,
  //     PageSize: 0
  //   };

  //   this._dashboardService.PerformDashboardSearchImplementLocationHistory(params).subscribe(result => {
  //     this.ImplementDetalisList = result;
  //     this.ImpLocationHistory.push(this.ImplementDetalisList);
  //     this.ImpLocationHistory[0].map(x => {
  //       x["CycleDetails"] = null
  //       this.historyDetails_ = [];
  //       this.loadImplementHistoryDetails(x.implementId, x.serialNo, this.ImpLocationHistory[0]);
  //     })

  //   })

  // }
  loadImp_Location_History() {

    this.loading = true;

    const params: SearchFilters = {
      customer: this.searchParameters.customer,
      jobsite: this.searchParameters.jobsite,
      equipment: this.searchParameters.equipment,
      make: this.searchParameters.make,
      makeUC: this.searchParameters.makeUC,
      model: this.searchParameters.model,
      implement: this.searchParameters.implement,
      ImplementTypes: this.searchParameters.ImplementTypes,
      ComponentTypes: this.searchParameters.ComponentTypes,
      onEq: this.searchParameters.onEq,
      evalA: false,
      evalB: false,
      evalC: false,
      evalX: false,
      NoImps: this.searchParameters.NoImps,
      family: this.searchParameters.family,
      assetSerial: this.searchParameters.assetSerial,
      GETType: this.searchParameters.GETType,
      PageNumber: 0,
      PageSize: 0
    };

    this._dashboardService
      .PerformDashboardSearchImplementLocationHistory(params)
      .subscribe(result => {

        this.ImplementDetalisList = result;
        this.ImpLocationHistory = [result];

        const requests = result.map(item => {
          item["CycleDetails"] = null;
          return this.loadImplementHistoryDetails(item.implementId, item.serialNo);
        });

        forkJoin(requests).subscribe(() => {

          // Find max row count after all APIs complete
          this.MaxLength = 0;

          this.ImpLocationHistory[0].forEach(x => {
            if (x.CycleDetails?.length > this.MaxLength) {
              this.MaxLength = x.CycleDetails.length;
              this.NewList = x.CycleDetails;
            }
          });
          this.loading = false;
        });
        this.loading = false;
        console.log("ImpLocationHistory", this.ImpLocationHistory);

        if (this.ImplementDetalisList.length == 0)
          this._notify.warn('No Record(s) Found!');
      });
  }

  loadImplementHistoryDetails(
    ImplementId: number,
    Imp_Name: string
  ) {

    return this._moduleService.GetImplementHistoryDetails(ImplementId).pipe(
      map(res => {

        this.historyDetails_ = [...res];

        this.historyDetails_ = this.historyDetails_.filter(x =>
          x.ActionDate != null &&
          (
            x.ActionName == "Attach Implement to Equipment" ||
            x.ActionName == "Move Implement to Inventory" ||
            x.ActionName == "Implement On Inventory"
          )
        );

        this.historyDetails_ = this.historyDetails_.filter((thing, index, self) =>
          index === self.findIndex(t =>
            t.ActionDate === thing.ActionDate &&
            t.ActionName === thing.ActionName
          )
        );

        this.loadLocationDetails(
          ImplementId,
          Imp_Name,
          this.historyDetails_
        );

        this.loadCycleDetails(
          ImplementId,
          Imp_Name,
          res
        );

        return true;
      })
    );
  }

  NewHistoryLocation: any[] = []
  loadLocationDetails(Imp_ID: number, Imp_Name: string, historyDetails: any) {

    const newsetArry = historyDetails.map((item, index) => ({
      data: index < historyDetails.length - 1
        ? [item, historyDetails[index + 1]]
        : [item]
    }));
    //console.log("newsetArry_"+ Imp_ID, newsetArry)
    var create_new_arr = [];

    newsetArry.forEach((m, arrIndex) => {

      let data = {
        location: '',
        Fitted_date: '',
        Removed_date: ''
      };

      const current = m.data?.[0];

      if (!current) {
        return;
      }

      // Set Location
      if (current.ActionName === 'Attach Implement to Equipment') {
        data.location = current.Unit;
      }
      else if (
        current.ActionName === 'Move Implement to Inventory' ||
        current.ActionName === 'Implement On Inventory'
      ) {
        data.location = 'Inventory';
      }

      // Always set fitted date from current action
      data.Fitted_date = current.ActionDate;

      // ==========================
      // First Record
      // ==========================
      if (arrIndex === 0) {

        if (current.ActionName === 'Attach Implement to Equipment') {
          data.Removed_date = '';
        }
        else if (
          current.ActionName === 'Move Implement to Inventory' ||
          current.ActionName === 'Implement On Inventory'
        ) {
          data.Removed_date = '';
        }
      }
      // ==========================
      // Other Records
      // ==========================
      else {

        if (current.ActionName === 'Attach Implement to Equipment') {

          const prevAction = newsetArry[arrIndex - 1]?.data?.[0];

          if (
            prevAction &&
            (
              prevAction.ActionName === 'Move Implement to Inventory' ||
              prevAction.ActionName === 'Implement On Inventory'
            )
          ) {
            // Rule 3:
            // Use previous inventory action date as removed date
            data.Removed_date = prevAction.ActionDate;
          }
          else {
            data.Removed_date = ' ';
          }
        }
        else {
          // Rule 2:
          // Inventory actions should never have a removed date
          data.Removed_date = ' ';
        }
      }
      create_new_arr.push(data);
    });

    this.NewCycleList = create_new_arr;
    let len = this.NewCycleList.length;
    if (this.MaxLength < len) {
      this.NewList = this.NewCycleList;
    }
    this.ImpLocationHistory[0].map(x => {
      if (x.implementId == Imp_ID) {
        x["CycleDetails"] = this.NewCycleList;
      }
    });
  }

  loadCycleDetails(Imp_ID: number, Imp_Name: string, historyDetails: any) {
    console.log("loadCycleDetails historyDetails", this.ImpLocationHistory, historyDetails)
    this.ImpLocationHistory[0].map(x => {
      if (x.implementId == Imp_ID) {
        let len = x.CycleDetails.length;
        if (this.MaxLength < len) {
          this.MaxLength = len;
          this.NewList = x.CycleDetails;
        }
        console.log("x.CycleDetails.map", x.CycleDetails);
        x.CycleDetails.map(cycle => {
          let CycleTotals = []
          //this.historyDetails_.map(y => {
          historyDetails.map(y => {
            //let ActionDate = new Date(y.ActionDate).getTime()
            //let StartDate = new Date(cycle.Fitted_date).getTime()
            let ActionDate = new Date(y.ActionDate).setHours(0, 0, 0, 0);
            let StartDate = new Date(cycle.Fitted_date).setHours(0, 0, 0, 0);
            let EndDate;
            var dateOffset = (24 * 60 * 60 * 1000) * 1;
            if (cycle.Removed_date == null || cycle.Removed_date == '') {
              EndDate = new Date().getTime()
              //if (this.newDAte != null)
              // StartDate = new Date(this.newDAte).getTime();
            } else {
              if (!cycle.Removed_date || cycle.Removed_date.trim() === '') {
                //EndDate = new Date().getTime()
                EndDate = StartDate;
              }
              else {
                EndDate = new Date(cycle.Removed_date).getTime();
                this.newDAte = EndDate;
              }
            }
            console.log("ActionDate >= StartDate && ActionDate <= EndDate, CycleTotals", ActionDate, StartDate, ActionDate, EndDate, CycleTotals);
            if (ActionDate >= StartDate && ActionDate <= EndDate) {
              CycleTotals.push(y);
            }
            let maxSMU = Math.max.apply(Math, CycleTotals.map(function (o) { return o.HoursDiff; }))
            // let minSMU = Math.min.apply(Math, CycleTotals.map(function(o) { return o.Hours; }))
            let TotalSMU = maxSMU;
            let maxBCM = Math.max.apply(Math, CycleTotals.map(function (o) { return o.BCM; }))
            let minBCM = Math.min.apply(Math, CycleTotals.map(function (o) { return o.BCM; }))
            let TotalBCM = maxBCM - minBCM;
            let maxTon = Math.max.apply(Math, CycleTotals.map(function (o) { return o.Tons; }))
            let minTon = Math.min.apply(Math, CycleTotals.map(function (o) { return o.Tons; }))
            let TotalTon = maxTon - minTon;
            let totalcost = 0
            CycleTotals.map(xy => {
              totalcost = totalcost + xy.Cost;
            })
            if (TotalSMU == -Infinity)
              TotalSMU = 0
            if (TotalBCM == -Infinity)
              TotalBCM = 0
            if (TotalTon == -Infinity)
              TotalTon = 0
            cycle["newArray"] = CycleTotals;
            cycle["TotalSMU"] = TotalSMU ?? 0;
            cycle["TotalBCM"] = TotalBCM ?? 0;
            cycle["TotalTon"] = TotalTon ?? 0;
            cycle["TotalCost"] = totalcost ?? 0;
            cycle["Implement"] = Imp_Name;
          })
        })
      }
    })

  }

  ToDecimalPoints(val1, val2) {

    let costper = val1 / val2;
    if (costper == Infinity)
      costper = 0;
    return costper.toFixed(2);
  }

  openImplementDetails(implementId: number): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/implementdetails', implementId])
    );

    if (this.tabReplace == "True") {
      // Open in same tab
      this.router.navigate(['/implementdetails', implementId]);
    } else {
      // Open in new tab
      window.open(url, '_blank');
    }
  }
}



